import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Home';
import NotFound from './components/NotFound';
//import Discography from './discography';
//import ScrollToTopRoute from './components/scrolltoTop'

 
   
const App = () => (
  <BrowserRouter>
            <Routes>
             <Route path="/" element={<Home/>} />
             {/*<ScrollToTopRoute path="/discography" component={Discography}/> 
             // The Discography component is temporarily commented out */}
            <Route path="*" element={<NotFound/>}/>
           </Routes>
      </BrowserRouter>
    )


export default App;
